import { render, staticRenderFns } from "./datagramDetail.vue?vue&type=template&id=0c914b4c&scoped=true"
import script from "./datagramDetail.vue?vue&type=script&lang=js"
export * from "./datagramDetail.vue?vue&type=script&lang=js"
import style0 from "./datagramDetail.vue?vue&type=style&index=0&id=0c914b4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c914b4c",
  null
  
)

export default component.exports